<template>
  <div>
    <div class="page-login__content">Enter the email for your member portal account, and we'll send you a reset link.</div>
    <form @submit.prevent="reset">
      <div class="row text-center">
        <div class="col-sm-8 col-sm-offset-2">
          <div class="row page-login__sign-in-row">
            <div class="col-sm-12 text-center">
              <input class="page-login__login-input list-group-item form-control" type="text" v-model="email" name="email" placeholder="email" data-placeholder="email" />
            </div>
          </div>
        </div>
      </div>
      <div class="row text-center">
        <div class="col">
          <button class="page-login__login-btn" type="submit" :disabled="!isEmailValid">Send Reset Link</button>
        </div>
      </div>
      <div class="row text-center">
        <div class="col">
          <a class="page-login__trouble-link" @click.prevent="toLogin">Return to login</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'ResetForm',
    data() {
      return {
        email: null,
        loading: false,
      };
    },
    computed: {
      isEmailValid() {
        return (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/.test(this.email));
      },
    },
    watch: {
      loading() {
        this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: this.loading });
      },
    },
    mounted() {
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
    methods: {
      reset() {
        this.loading = true;
        this.$store.dispatch('auth/reset', { email: this.email })
          .then(() => {
            this.loading = false;
            this.email = null;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      toLogin() {
        this.$store.dispatch('auth/setProperty', { key: 'error', value: false });
        this.$store.dispatch('auth/setProperty', { key: 'message', value: null });
        this.$router.push({ name: 'login' });
      },
    },
  };
</script>
